module.exports = __webpack_public_path__ + "img/20180815_154807_238.66fbe083.jpg";